import { Map } from 'ol';
import React from 'react';

interface IImageMapContext {
  map?: Map;
}

export const ImageMapContext = React.createContext<IImageMapContext>({} as IImageMapContext);
ImageMapContext.displayName = 'ImageMapContext';
